/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useEffect, useState} from 'react';
import {useForm} from "react-hook-form";
import {useNavigate} from "react-router-dom";
import Loader from "../elements/loader";
import useAxiosJTW from "../Hooks/useAxiosJTW";
import {ReactComponent as Exclamation} from "../assets/img/icons/exclamation-grey.svg";
import VehicleLicence from "./VehicleLicence";
import {useTranslation} from "react-i18next";

const ModelPartsForm = (props) => {

    const axiosJWT = useAxiosJTW();
    let navigate = useNavigate();
    const { t, i18n } = useTranslation();

    const [modelYearStage, setModelYearStage] = useState({isLoading: false, data: [], error: false});
    const [typeStage, setTypeStage] = useState({isLoading: false, data: [], error: false});
    const [yearRangeStage, setYearRangeStage] = useState({isLoading: false, data: [], error: false});

    const { register, handleSubmit, watch, formState: { errors }, reset, setValue, getValues } = useForm({
        mode: "onChange"
    });

    const watchModel = watch("model", false);
    const watchType = watch("type", false);

    const getTypeByModel = (model) => {
        axiosJWT.post('api/gettypebymodel', { model: model }).then( (response) => {
            if(response.status === 200){
                setTypeStage({...typeStage, data: response.data.types || [], isLoading: false});
            }
        } ).catch((error) => {
            console.log(error);
        });
    }

    const getModelDatesRange = (model, data) => {
        axiosJWT.post('api/getmodeldatesrange', { model: model, type: data[0], doors: data[1] }).then( (response) => {
            if(response.status === 200){
                setYearRangeStage({...yearRangeStage, data: response.data.date_range || [], isLoading: false});
            }
        } ).catch((error) => {
            console.log(error);
        });
    }

    const onModelSelect = (data) =>{
        //reset({year: '', type: '', yearRange: ''});
        setValue('type', '');
        setValue('yearRange', '');
        //
        setValue('model', data);
        setTypeStage({...typeStage, isLoading: true});
        getTypeByModel(data);
    }

    const onTypeSelect = (data) =>{
        //reset({yearRange: ''});
        setValue('yearRange', '');
        //
        const _model = getValues('model');
        setValue('type', data);

        const _data = data.split(',');
        setYearRangeStage({...yearRangeStage, isLoading: true});
        getModelDatesRange(_model, _data);
    }
    const onRangeSelect = (data) =>{
        setValue('yearRange', data);
    }
    const onSubmit = data => {

        const selectedType = getValues("type");
        const _data = selectedType.split(',');
        const currentBody = typeStage.data.find(option => option.body_type_id === _data[0]);

        navigate(`/${i18n.language}/parts/${props.selectedMake}/${data.model}/${data.yearRange}?bodytype=${data.type}&bodytypeTitle=${currentBody.title}`);
    };

    useEffect( ()=>{
        reset();
    },[] )

    return (
        <>
            {/*{props.models.length == 0 ? (*/}
            {/*    <div style={{ paddingTop: '20px', paddingBottom: '20px', textAlign : 'center', margin: '0 auto' }}>Δεν βρέθηκαν μοντέλα</div>*/}
            {/*) : (*/}
            <div className='SearchByCar__form pt-2 pb-2'>
                <VehicleLicence/>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-row align-items-start">
                        <div className="form-group col-sm">
                            <label htmlFor='model' className='font-weight-bold'>{ t('fields.model' ) }</label>
                            {props.modelLoading ? (
                                <div className='small' style={{ position: 'absolute', top : '16px' }}><Loader/></div>
                            ) : (
                                <select id='model' className='form-control' defaultValue="" {...register("model", {required: `${t('fields.requiredfield')}`})} onChange={ (e) => {onModelSelect(e.target.value)} }>
                                    <option value="" disabled>{t('fields.Select')}</option>
                                    {props.models.map((option, i) => <option key={i} value={option.model_name}>{option.model_name}</option>)}
                                </select>
                            )}
                            { errors.model && <small className="text-danger">{errors.model?.message}</small>}
                        </div>
                        {/*<div className="form-group col-sm">*/}
                        {/*    <label htmlFor='year' className='font-weight-bold'>Model Year</label>*/}
                        {/*    {modelYearStage.isLoading ? (*/}
                        {/*        <div className='small' style={{ position: 'absolute', top : '16px' }}><Loader/></div>*/}
                        {/*    ) : (*/}
                        {/*        <select id='year' className='form-control' disabled={!watchModel} defaultValue="" {...register("year", {required: `${t('fields.requiredfield')}`})} onChange={ (e) => {onYearSelect(e.target.value)} }>*/}
                        {/*            <option value="" disabled>{t('fileds.Select')}</option>*/}
                        {/*            {modelYearStage.data.map((option, i) => <option key={i} value={option.model_year}>{option.model_year}</option>)}*/}
                        {/*        </select>*/}
                        {/*    )}*/}
                        {/*    { errors.year && <small className="text-danger">{errors.year?.message}</small>}*/}
                        {/*</div>*/}
                        <div className="form-group col-sm">
                            <label htmlFor='type' className='font-weight-bold'>{ t('fields.type' ) }</label>
                            {typeStage.isLoading ? (
                                <div className='small' style={{ position: 'absolute', top : '16px' }}><Loader/></div>
                            ) : (
                                <select id='type' className='form-control' disabled={!watchModel} defaultValue="" {...register("type", {required: `${t('fields.requiredfield')}`})} onChange={ (e) => {onTypeSelect(e.target.value)} }>
                                    <option value="" disabled>{t('fields.Select')}</option>
                                    {typeStage.data.map((option, i) => <option key={i} value={[option.body_type_id, option.doors]}>{option.title} / {option.doors}</option>)}
                                </select>
                            )}
                            { errors.type && <small className="text-danger">{errors.type?.message}</small>}
                        </div>
                        <div className="form-group col-sm">
                            <label htmlFor='yearRange' className='font-weight-bold'>{ t('fields.yearRange' ) }</label>
                            {yearRangeStage.isLoading ? (
                                <div className='small' style={{ position: 'absolute', top : '16px' }}><Loader/></div>
                            ) : (
                                <select id='yearRange' className='form-control' disabled={!watchType} defaultValue="" {...register("yearRange", {required: `${t('fields.requiredfield')}`})} onChange={ (e) => {onRangeSelect(e.target.value)} }>
                                    <option value="" disabled>{t('fields.Select')}</option>
                                    {yearRangeStage.data.map((option, i) => <option key={i} value={option.url}>{option.title}</option>)}
                                </select>
                            )}
                            { errors.yearRange && <small className="text-danger">{errors.yearRange?.message}</small>}
                        </div>
                        <div className="form-group col">
                            <label className='font-weight-bold' style={{ minHeight: '14px' }}></label>
                            <button className="SearchByCar__btn btn btn-primary btn-icon btn-icon-right" type='submit'>
                                { t('parts.findSpare' ) }
                                <svg xmlns="http://www.w3.org/2000/svg" width="6.121" height="9.414" viewBox="0 0 6.121 9.414"><path d="M0,0,4,4,8,0" transform="translate(0.707 8.707) rotate(-90)" fill="none" stroke="#fff" strokeWidth="2"></path></svg>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            {/*)}*/}

        </>
    );
};

export default ModelPartsForm;
